import React from "react";
import { makeStyles } from "e100-react-components";

const useStyles = makeStyles(({ spacing, palette }) => ({
  circle: {
    height: 140,
    width: 140,
  },
  circlePath: {
    stroke: "#50BC46",
    fill: "none",
    strokeWidth: 1.5,
  },
  circlePathBg: {
    stroke: "#E1E5E8",
    fill: "none",
    strokeWidth: 1,
  },
  icon: {
    position: "absolute",
    right: "50%",
    top: "50%",
    transform: "translate(50%, -50%)",
  },
  spinnerContainer: {
    position: "relative",
    width: "fit-content",
  },
}));

export interface ProgressBarProps {
  icon?: JSX.Element | null;
  completedPercent?: number;
}

export const ProgressBar = ({ icon, completedPercent }: ProgressBarProps) => {
  const classes = useStyles();
  return (
    <div className={classes.spinnerContainer}>
      <svg viewBox="0 0 36 36" className={classes.circle}>
        <path
          className={classes.circlePathBg}
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className={classes.circlePath}
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none"
          stroke="#E1E5E8"
          stroke-width="1px"
          stroke-dasharray={`${completedPercent ?? 0}, 100`}
        />
      </svg>
      {icon && <div className={classes.icon}>{icon}</div>}
    </div>
  );
};
